import { InputBlockCombinedProps } from './types';

const usePresenter = (props: InputBlockCombinedProps): InputBlockCombinedProps => {
  return props;
};

export default usePresenter;
